import Layout from "../../../components/layout/layout.js";
import MeasurementImport from "../../../components/measurement-import/MeasurementImport.js";

function MeasurementImportPage({ component, ...rest }) {
  return (
    <Layout Component={MeasurementImport} controlsDisabled={true} {...rest} />
  );
}

export default MeasurementImportPage;
